import { OrganizationKeyName } from "../../../model/Organization";

export const GET_PRODUCT_CATEGORY_LIST = "SHOP:GET_PRODUCT_CATEGORY_LIST";

export const getProductCategoryListAction = (
  organization: OrganizationKeyName
) => ({
  type: GET_PRODUCT_CATEGORY_LIST as typeof GET_PRODUCT_CATEGORY_LIST,
  organization,
});

export type GetProductCategoryListAction = ReturnType<
  typeof getProductCategoryListAction
>;
